module.exports = __webpack_public_path__ + "img/img9.ea463c7b.svg";